import React from 'react';

import Modal from '~components/Modal';

import UploadMultiple from './UploadMultiple';

interface ComponentProps {
  isOpen: boolean;
  onClose: () => void;
}

const AcoImportModal: React.FC<ComponentProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(toggle) => (toggle ? undefined : onClose())}
      header={<span>ACO Budgets Import</span>}
      headerClassName="header"
      size="lg"
    >
      <UploadMultiple />
    </Modal>
  );
};

export default AcoImportModal;
